import React, { useState, useEffect } from "react";
import { Device } from "twilio-client";
import states from "./states";
import { log } from "util";
import requestUtil from "../../helpers/requestUtil";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import "./twillio.css";
import { toast } from "react-toastify";

const Phone = ({ phoneNumber, candidateUniqueId, getCallHistoryList, handleClose, jobsClaimId, jobsShiftUniqueId }) => {
  const config = useConfiguration();
  const [state, setState] = useState(states.CONNECTING);
  const [conn, setConn] = useState(null);
  const [device, setDevice] = useState(null);
  const [token, setToken] = useState(null);
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const [number, setNumber] = useState(`${login.countryPhoneCode}${phoneNumber.replace(/-/g, '')}`);
  // Call Timer Settings
  const [isRunning, setIsRunning] = useState(false);
  const [totalSeconds, setTotalSeconds] = useState(0);
  const [callIsStarted, setcallIsStarted] = useState("");
  const [callisGreenFlag, setcallisGreenFlag] = useState(false);
  const [callhangupEnable, setCallhangupEnable] = useState(true);
  const [callerId, setCallerId] = useState('');

  useEffect(async () => {
    if (config.baseUrl) {
      const data = await requestUtil(
        `${config.baseUrl}/Voice/get-twilio-callerid?jobsShiftUniqueId=${jobsShiftUniqueId ? jobsShiftUniqueId : null}&employerUniqueId=${login.employerUniqueId}`,
        "GET"
      );
      setCallerId(data?.twilioCallerId);
      if (!data?.twilioCallerId) {
        toast.warn('Phone number not mapped to this user.')
      }
    }
  }, [config]);

  useEffect(() => {
    if (token) {
      const device = new Device();
      device.setup(token?.token, {
        logLevel: 1,
        codecPreferences: ["opus", "pcmu"],
      });
      device.on("ready", (device) => {
        setDevice(device);
        setState(states.READY);
      });
      device.on("connect", (connection) => {
        setConn(connection);
        setState(states.ON_CALL);
        // Call Started
        handleStart();
        setcallIsStarted("Call connected...");
        setcallisGreenFlag(true);
      });

      device.on("disconnect", () => {
        setState(states.READY);
        setConn(null);
        // Call Disconnected
        setcallIsStarted("Call disconnected...");
        // getCallHistoryList(`${login.countryPhoneCode}${phoneNumber}`);
        setcallisGreenFlag(false);
        handleClose();
        setTimeout(() => {
          setcallIsStarted("");
          handleStop();
          toast.warning('Call disconnected...')
        }, 1000);
      });

      device.on("incoming", (connection) => {
        setState(states.INCOMING);
        setConn(connection);
        connection.on("reject", () => {
          setState(states.READY);
          setConn(null);
        });
      });

      device.on("cancel", () => {
        setState(states.READY);
        setConn(null);
      });
      device.on("reject", () => {
        setState(states.READY);
        setConn(null);
      });
      return () => {
        device.destroy();
        setDevice(null);
        setState(states.OFFLINE);
      };
    }
  }, [token]);

  useEffect(async () => {
    if (config.baseUrl) {
      const data = await requestUtil(
        `${config.baseUrl}/Voice/get-twilio-token`,
        "GET"
      );
      if (data) {
        setToken(data);
      }
    }
  }, [config]);
  // Start Call
  const handleCall = () => {
    if (number) {
      const params = {
        toNumber: number,
        callingDeviceIdentity: token?.identity,
        appUserUniqueId: login.appUserUniqueId,
        candidateUniqueId: candidateUniqueId,
        isFromAdmin : false,
        isFromCandidate: false,
			  jobsShiftUniqueId,
			  jobsClaimId,
        twilioCallerId: callerId,
        websiteDomainName: window.location.hostname
      };
      console.log(params);
      device.connect({ ...params });
    }
  };
  // End Call
  const handleHangup = () => {
    device.disconnectAll();
  };

  // Call Timer Settings Section
  useEffect(() => {
    let timerId;
    if (isRunning) {
      timerId = setInterval(() => {
        setTotalSeconds((prevSeconds) => prevSeconds + 1);
      }, 1000);
    }

    return () => {
      if (timerId) {
        clearInterval(timerId);
      }
    };
  }, [isRunning]);

  // Call Start Timer
  const handleStart = () => {
    setIsRunning(true);
    setTimeout(() => {
      setCallhangupEnable(false);
    },3000)
  };
  

  // Call Stop Timer
  const handleStop = () => {
    setIsRunning(false);
    setCallhangupEnable(true);
    setTimeout(() => {
      setTotalSeconds(0);
    }, 1000);
  };
  // Call Time Fomat
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedTime = `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
    return formattedTime;
  };

  return (
    <div className="d-flex gap-3 justify-content-center">
      <div className="d-flex flex-column gap-2">
        <input
          readOnly={true}
          className="form-control"
          type="tel"
          placeholder="Enter phone number"
          value={number.replace(/-/g, "")}
          onChange={(e) => setNumber(e.target.value)}
        />
        {callIsStarted ? (
          <div
            className={
              callisGreenFlag
                ? "text-success fw-bold d-flex gap-3"
                : "text-danger fw-bold d-flex gap-3"
            }
          >
            {formatTime(totalSeconds)}{" "}
            <span className="blinking-text">{callIsStarted}</span>{" "}
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="d-flex gap-3">
        <button
          onClick={handleCall}
          className="border border-0"
          disabled={!callerId}
          style={{
            height: "40px",
            width: "40px",
            borderRadius: "70%",
            backgroundColor: "green",
          }}
        >
          <i
            class="fa fa-phone "
            style={{ color: "white", fontSize: "20px" }}
          ></i>
        </button>

        <button
          onClick={handleHangup}
          disabled={callhangupEnable}
          className="border border-0"
          style={{
            height: "40px",
            width: "40px",
            borderRadius: "70%",
            backgroundColor: "red",
          }}
        >
          <i
            class="fa fa-phone"
            style={{ color: "white", fontSize: "20px" }}
          ></i>
        </button>
      </div>
    </div>
  );
};

export default Phone;
